import { InteractiveObject } from "../interactive-object.js";
/**
 * MarkerType - this enum defines the list of predefined marker types.
 */
export var MarkerType;
(function (MarkerType) {
    /** No marker. */
    MarkerType[MarkerType["None"] = 0] = "None";
    /** Sphere marker. */
    MarkerType[MarkerType["Sphere"] = 1] = "Sphere";
    /** Arrow marker. */
    MarkerType[MarkerType["Arrow"] = 2] = "Arrow";
})(MarkerType || (MarkerType = {}));
/**
 * Represents interactive line segment.
 */
export class InteractiveLine extends InteractiveObject {
    /** Empty constructor. */
    constructor(theViewer, theObjId = "") {
        super(theViewer, theObjId);
        if (this._myObjId === "") {
            this._myObjId = "_InteractiveLine";
        }
        this._myViewer.interactiveLineController.createLineSegment(this._myObjId);
        this._myViewer.interactiveContext.displayObjectList(`${this._myObjId}`, false);
    }
    /** Make a copy of existing object with new id */
    clone() { return new InteractiveLine(this._myViewer, super._clone()); }
    /** Return segment points. */
    get segment() {
        return this._myViewer.interactiveLineController.getLineSegment(this._myObjId);
    }
    /** Set segment points. */
    set segment(theSeg) {
        this._myViewer.interactiveLineController.setLineSegment(this._myObjId, theSeg);
    }
    /** Return segment point. */
    get pointFrom() { return this.segment.from; }
    /** Set segment point. */
    set pointFrom(thePoint) {
        this.segment = { from: thePoint, to: this.segment.to };
    }
    /** Return segment point. */
    get pointTo() { return this.segment.to; }
    /** Set segment point. */
    set pointTo(thePoint) {
        this.segment = { from: this.segment.from, to: thePoint };
    }
    /** Return line type */
    get lineType() {
        return this._myViewer.interactiveLineController.getLineType(this._myObjId);
    }
    /** Set line type */
    set lineType(theType) {
        this._myViewer.interactiveLineController.setLineType(this._myObjId, theType);
    }
    /** Return line width. */
    get lineWidth() {
        return this._myViewer.interactiveLineController.getLineWidth(this._myObjId);
    }
    /** Set line width. */
    set lineWidth(theWidth) {
        this._myViewer.interactiveLineController.setLineWidth(this._myObjId, theWidth);
    }
    /** Return marker type. */
    getMarkerType(theIdx) {
        return this._myViewer.interactiveLineController.getLineMarkerType(this._myObjId, theIdx);
    }
    /** Set marker type. */
    setMarkerType(theIdx, theType) {
        this._myViewer.interactiveLineController.setLineMarkerType(this._myObjId, theIdx, theType);
    }
    /** Return marker size. */
    get markerSize() {
        return this._myViewer.interactiveLineController.getLineMarkerSize(this._myObjId);
    }
    /** Set marker size. */
    set markerSize(theSize) {
        this._myViewer.interactiveLineController.setLineMarkerSize(this._myObjId, theSize);
    }
}
